import { HelpButton, SelectItem, tokens, Typography } from '@sapphire-react/core';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getPartnershipValues } from '../../constants/getPartnershipValues';
import { Link } from '../Link';
import { SelectField } from '../SelectField';

type Props = {
  control: Control<any>;
  withSecondaryApplicant: boolean;
};

export function Partnership({ withSecondaryApplicant, control }: Props) {
  const { t } = useTranslation();
  const values = getPartnershipValues(withSecondaryApplicant);

  const partnershipInquiryFieldRules = {
    required: t('shared:personalInformation.inputs.partnership.requiredError'),
  };

  return (
    <SelectField
      control={control}
      name={'partnership'}
      data-test-id={'partnership'}
      placeholder={values.placeholder}
      rules={partnershipInquiryFieldRules}
      label={values.label}
      width={'100%'}
      contextualHelp={
        <PartnershipContextualHelp
          withSecondaryApplicant={withSecondaryApplicant}
        />
      }
    >
      <SelectItem key={'A1'} data-test-id={'saco'}>
        {values.saco}
      </SelectItem>
      <SelectItem key={'B1'} data-test-id={'tco'}>
        {values.tco}
      </SelectItem>
      <SelectItem key={'C1'} data-test-id={'hsb'}>
        {values.hsb}
      </SelectItem>
      <SelectItem key={'SPP'} data-test-id={'spp'}>
        {values.spp}
      </SelectItem>
      <SelectItem key={'null'} data-test-id={'noneApplies'}>
        {values.noneApplies}
      </SelectItem>
    </SelectField>
  );
}

function PartnershipContextualHelp({
  withSecondaryApplicant,
}: {
  withSecondaryApplicant: boolean;
}) {
  const { t } = useTranslation();

  const tooltipTexts = {
    firstParagraph: withSecondaryApplicant
      ? t(
          'shared:personalInformation.inputs.partnership.tooltip._1.withSecondary',
        )
      : t(
          'shared:personalInformation.inputs.partnership.tooltip._1.withoutSecondary',
        ),
    secondParagraph: withSecondaryApplicant
      ? t(
          'shared:personalInformation.inputs.partnership.tooltip._2.withSecondary',
        )
      : t(
          'shared:personalInformation.inputs.partnership.tooltip._2.withoutSecondary',
        ),
    link: withSecondaryApplicant
      ? t(
          'shared:personalInformation.inputs.partnership.tooltip.link.withSecondary',
        )
      : t(
          'shared:personalInformation.inputs.partnership.tooltip.link.withoutSecondary',
        ),
  };

  return (
    <HelpButton
      variant={'help'}
      aria-label={'Hjälp!'}
      contentBody={
        <>
          <Typography.Body size={'sm'}>
            {tooltipTexts.firstParagraph}
          </Typography.Body>
          <Typography.Body marginTop={tokens.size.spacing2xs} size={'sm'}>
            {tooltipTexts.secondParagraph}
          </Typography.Body>
          <Typography.Body size={'md'}>
            <Link marginTop={tokens.size.spacingMd}>
              <a
                href={'https://danskebank.se/medlemifacket'}
                target={'_blank'}
                rel={'noreferrer'}
              >
                {tooltipTexts.link}
              </a>
            </Link>
          </Typography.Body>
        </>
      }
    />
  );
}
